import type { PropsWithChildren } from 'react'
import React, { useContext } from 'react'

type HexColor = `#${string}`

type SiteContextValue = {
  presentation_webinarRoomAccentColor?: HexColor
  presentation_webinarRoomSidebarBackgroundColor?: HexColor
  presentation_webinarRoomTabBackgroundColor?: HexColor
  site_url: string
}

const SiteContext = React.createContext<SiteContextValue | null>(null)

export type { SiteContextValue }

type SiteProviderProps = PropsWithChildren<{
  value: SiteContextValue
}>

const SiteProvider = ({ value, children }: SiteProviderProps) => {
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>
}

function useSite() {
  const context = useContext(SiteContext)

  if (context === null) {
    throw new Error('useSite must be used within a SiteProvider component')
  }

  return context
}

export { useSite, SiteProvider }

// Keeping this here because it is used all over the place.
export default SiteContext
